import { Stack } from '@mantine/core';
import { observer } from 'mobx-react-lite';
import * as React from 'react';

import { userStore } from 'stores/global/RootStore';
import { useAppConfig } from 'stores/global/RootStore/context';
import { useLkLayoutStore } from 'stores/local/layout/LkLayoutStore';

import MenuItem from './MenuItem';
import { getMenuItemLabel, isMenuItemVisible, MENU_ITEMS } from './config';

type Props = {
  className?: string;
};

export const Menu: React.FC<Props> = ({ className }) => {
  const { menu } = useLkLayoutStore();
  const { user } = userStore;
  const { logic } = useAppConfig();

  const visibleItems = MENU_ITEMS.filter((item) => isMenuItemVisible(item, logic, user));

  if (!user) {
    return null;
  }

  return (
    <Stack className={className}>
      <Stack gap={4}>
        {visibleItems.map((item) => (
          <MenuItem
            key={item.to}
            {...item}
            label={getMenuItemLabel(item, logic.sectionTitles)}
            collapsed={!menu.isOpen}
          />
        ))}
      </Stack>
    </Stack>
  );
};

export default observer(Menu);
